import config from "appConfig";
import { LayoutComponents } from "packages/lesson/dist/@types";

const components: LayoutComponents = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 4,
        rows: 4,
        colSpan: {
          "0:0": 2,
        },
        rowSpan: {
          "0:0": 4,
        },
        colsSize: [1.9, 0.1, 0.1, 1.9],
        rowsSize: [0.5, 0.5, 0.5, 0.5],
        components: [
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/05/30/principle/scenario-2-3.svg`,
                  },
                },
              },
            },
            null,
            null,
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data: `RESHAPING THE INITIAL ROOM LAYOUT: CONVENTIONAL RECTANGULAR SHAPE`,
                    scrollbars: false,
                    formatter: "html",
                    styles: {
                      fontWeight: 700,
                      lineHeight: "18px",
                      fontSize: "16px",
                    },
                  },
                },
                styles: {
                  alignItems: "flex-end",
                  justifyContent: "flex-start",
                  paddingBottom: "5%",
                },
              },
            },
          ],
          [
            null,
            null,
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/05/30/principle/smile-happy.svg`,
                    styles: {
                      width: "20px",
                      height: "20px",
                    },
                  },
                },
                styles: {
                  justifyContent: "flex-end",
                  alignItems: "flex-start",
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data: `<span style="font-size: 16px; font-weight: 700;">SPACE SAVINGS</span><br />The surface area of the room is now met. However,`,
                    scrollbars: false,
                    formatter: "html",
                    styles: {
                      fontWeight: 400,
                      lineHeight: "18px",
                      fontSize: "14px",
                    },
                  },
                },
                styles: {
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                },
              },
            },
          ],
          [
            null,
            null,
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/05/30/principle/smile-happy-dark.svg`,
                    styles: {
                      width: "20px",
                      height: "20px",
                    },
                  },
                },
                styles: {
                  justifyContent: "flex-end",
                  alignItems: "flex-start",
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data: `<span style="font-size: 16px; font-weight: 700;">ACOUSTICALLY</span><br />A rectangular shape with reflective parallel surfaces avoids focusing but will lead to unwanted acoustic effects such as flutter echoes.<br /><br /><span style="font-weight: 700;">This is not recommended for a music space. Additional treatments are required to meet the acoustic requirements for a music room.</span>`,
                    scrollbars: false,
                    formatter: "html",
                    styles: {
                      textAlign: "left",
                      fontWeight: 400,
                      lineHeight: "18px",
                      fontSize: "14px",
                    },
                  },
                },
                styles: {
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                },
              },
            },
          ],
          [
            null,
            null,
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/05/30/principle/smile-sad-dark.svg`,
                    styles: {
                      width: "20px",
                      height: "20px",
                    },
                  },
                },
                styles: {
                  justifyContent: "flex-end",
                  alignItems: "flex-start",
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data: `<span style="font-size: 16px; font-weight: 700;">COST SAVINGS</span><br />Another acoustic treatment will need to added to make this space suitable for music.`,
                    scrollbars: false,
                    formatter: "html",
                    styles: {
                      fontWeight: 400,
                      lineHeight: "18px",
                      fontSize: "14px",
                    },
                  },
                },
                styles: {
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                },
              },
            },
          ],
        ],
      },
    },
  },
];

export default components;
